import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { FaRegEyeSlash } from 'react-icons/fa';
import { IoEyeOutline } from 'react-icons/io5';
import { InfinitySpin, Oval } from 'react-loader-spinner';
import { useSelector } from 'react-redux';
import undraw from '../assets/forgotpass.svg'
import { useParams, useSearchParams } from 'react-router-dom';
import { api_url } from '../utils/Config';
import { toast } from 'react-toastify';

// import api from '../../utils/api';

const ResetPasswordPage = ({ setModal, modal, handleLogout }) => {

    const [status, setStatus] = useState('')
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const [email,setEmail]= useState('')
    const [oldpassword, setOldpassword] = useState('')
    const [newpassword, setNewpassword] = useState('')
    const [password_confirmation, setPassword_confirmation] = useState('')
    const [newpasswordState, setNewpasswordState] = useState(false);
    const [oldpasswordState, setOldpasswordState] = useState(false);
    const [confirm_passwordState, setConfirm_passwordState] = useState(false)
    const [searchParams] = useSearchParams()
    const { token } = useParams()

    useEffect(() => {
        setEmail(searchParams.get("email"))
    }, [])

    const handleOldPasswordToggle = (e) => {
        e.preventDefault();
        setOldpasswordState(!oldpasswordState);
    };
    const handleNewPasswordToggle = (e) => {
        e.preventDefault();
        setNewpasswordState(!newpasswordState);
    };
    const handleConfirmPasswordToggle = (e) => {
        e.preventDefault();
        setConfirm_passwordState(!confirm_passwordState)
    }

    const handlePasswordUpdate = async (e) => {
        e.preventDefault()
        const password_details = {
            token,
            email,
            password: newpassword,
            password_confirmation,
        }
        const required = !newpassword || !password_confirmation
        if (required) {
            setError(`Please fill all required field`)
            setTimeout(() => {
                setError('');
            }, 6000);
            return
        }


        try {
            setLoading(!loading)
            await axios.post(api_url+'/reset-password', password_details, {
                headers: {
                    "Content-Type": "application/json",
                    // Authorization: `Bearer ${token}`
                }
            })

            setStatus('Password Updated Successfully')
            toast.success('Password Updated Successfully')
            setLoading(false)
            setTimeout(() => {
                handleLogout()
            }, 1500);
        } catch (error) {
            console.log(error.message);
            setError(error?.response?.data?.error)
            toast.error('Sorry, an error occured')
        } finally {
            setLoading(false)
            setTimeout(() => {
                setError('');
            }, 6000);
        }
    }

    return (
        <div className='h-screen flex justify-center items-center w-full'>
            <div className='flex justify-center items-center rounded-lg max-w-[1240px]'>
                <div className='w-1/2 hidden sm:block rounded-l-lg p-10 border-r'>
                    <img
                        src={undraw}
                        className=' mx-auto '
                    />
                </div>
                <div className='max-w-2xl  overflow-auto sm:min-w-[400px]  mx-auto p-4'>
                    <div className=' mb-6'>
                        <p className='font-lufga text-center font-semibold text-neutral-500'>Update User Password</p>

                    </div>
                    <form className="grid gap-4 mb-6 md:grid-cols-1">
                      
                        <div>
                            <label
                                htmlFor='password'
                                className='block mb-2 text-sm font-medium text-gray-900 font-lufga '
                            >
                                New Password
                            </label>
                            <div className='flex justify-between items-center bg-gray-50 border text-xs border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600  w-full p-2.5'>
                                <input
                                    value={newpassword}
                                    onChange={(e) => setNewpassword(e.target.value)}
                                    type={newpasswordState ? 'text' : 'password'}
                                    name='password'
                                    placeholder='••••••••'
                                    className='bg-gray-50 focus:outline-none w-full'
                                    required
                                />
                                {newpasswordState ? (
                                    <IoEyeOutline size={20} onClick={handleNewPasswordToggle} />
                                ) : (
                                    <FaRegEyeSlash size={20} onClick={handleNewPasswordToggle} />
                                )}
                            </div>
                        </div>
                        <div>
                            <label
                                className='block mb-2 font-lufga text-sm font-medium text-gray-900 '
                            >
                                Confirm New Password
                            </label>
                            <div className='flex justify-between items-center bg-gray-50 border text-xs border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600  w-full p-2.5'>
                                <input
                                    value={password_confirmation}
                                    onChange={(e) => setPassword_confirmation(e.target.value)}
                                    type={confirm_passwordState ? 'text' : 'password'}
                                    name='confirm_password'
                                    placeholder='••••••••'
                                    className='bg-gray-50 focus:outline-none w-full'
                                    required
                                />
                                {confirm_passwordState ? (
                                    <IoEyeOutline size={20} onClick={handleConfirmPasswordToggle} />
                                ) : (
                                    <FaRegEyeSlash size={20} onClick={handleConfirmPasswordToggle} />
                                )}
                            </div>
                        </div>
                    </form>
                     <div className='flex sm:justify-end'>
                                        <button
                                            disabled={loading}
                                            onClick={handlePasswordUpdate}
                                            className='w-full sm:w-fit font-lufga text-white bg-[#1330C5] hover:opacity-90 focus:outline-none rounded-md shadow-md text-base px-4 py-2 sm:px-10 sm:py-2 text-center'
                                        >
                                            {loading ? (
                                                <div className=" flex justify-center items-center">
                                                    <Oval
                                                        visible={true}
                                                        height="20"
                                                        width="20"
                                                        color="#ffff"
                                                        ariaLabel="oval-loading"
                                                        wrapperStyle={{}}
                                                        wrapperClass=""
                                                    />
                                                </div>
                                            ) : 'Update Password'}
                                        </button>
                                    </div>
                    <div className='mt-2'>
                        {status &&
                            <div>
                                <p className="bg-green-300 font-lufga rounded-md shadow-md px-2 py-1 text-xs text-center">{status}</p>
                            </div>
                        }
                        {error && (
                            <div>
                                <p className="bg-red-300 font-lufga rounded-md shadow-md px-2 py-1 text-xs ">
                                    {typeof error === 'string' ? error : (
                                        Object.keys(error).map((key) => (
                                            Array.isArray(error[key]) ? error[key][0] : error[key]
                                        ))
                                    )}
                                </p>
                            </div>
                        )}
                    </div>

                </div>

            </div>
        </div>
    );
}

export default ResetPasswordPage;
